import Image from 'next/image'
import {
  Slide as SlideType,
  useLightboxState,
} from 'yet-another-react-lightbox'

import { getExternalImageURL } from '@/shared/ui'

type LightboxImageProps = {
  slide: SlideType
  roomName: string
}

export const Slide = ({ slide, roomName }: LightboxImageProps) => {
  const { currentIndex } = useLightboxState()

  return (
    <div className="relative h-full max-h-[80vh] w-full max-w-[80vw]">
      <Image
        src={getExternalImageURL({ src: slide.src })}
        alt={`${roomName} ${currentIndex + 1}번째 이미지`}
        className="object-contain"
        fill
      />
    </div>
  )
}
